module.exports = __webpack_public_path__ + "static/media/image9.bda7f95e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/OurTeam/image9.jpeg
// module id = 118
// module chunks = 0